export default function BannerItem({ img, className }) {
  return (
    <div className={className}>
      <img src={img} alt='' />
    </div>
  )
}